/**
 * Shared URL/path helpers (used by WorkflowListPage, TaskBoardPage, CustomerPage).
 */

/**
 * Get customer ID from URL when path is /customer/{id}/workflows|tasks|bots|operate.
 * Returns undefined for /customer/workflows or /customer/tasks (no customer context).
 */
export function getCustomerIdFromUrl(): string | undefined {
  const match = window.location.pathname.match(/^\/customer\/([^/]+)\/(?:workflows|tasks|bots|operate)/);
  return match ? match[1] : undefined;
}

/**
 * Get customer ID from URL when path is /customer/{id} or /customer/{id}/...
 * Use for customer dashboard. For workflow/task pages use getCustomerIdFromUrl().
 */
export function getCustomerIdFromPath(): string | undefined {
  const match = window.location.pathname.match(/^\/customer\/([^/]+)/);
  return match ? match[1] : undefined;
}

/**
 * Build query string for reseller/customer context: ?customer_id=...
 * Returns empty string when customerId is undefined.
 */
export function buildResellerQuery(customerId: string | undefined): string {
  return customerId ? `?customer_id=${encodeURIComponent(customerId)}` : '';
}
